import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import axios from 'axios';
import { Container, Row, Col, Button, Form, Input, Progress } from 'reactstrap';
import * as vars from '../../constants/constants';
import { show, hide } from '../../actions/ActivityIndicatorActions';
import { setHeaderTitle } from '../../actions/HeaderActions';
import { smartTvData } from '../../actions/SmartTVActions';
import { console_log, isBetween, formatDate } from '../../utils/helper';
import { FormattedMessage } from 'react-intl';

class SmartTV extends Component {
	constructor(props) {
		super(props);
		this.state = {
		    currentTime: new Date()
        };
        this.timeInterval = null;
        this.getSmartTv = this.getSmartTv.bind(this);
        this.getCurrentProgram = this.getCurrentProgram.bind(this);
        this.getNextProgram = this.getNextProgram.bind(this);
        this.getProgress = this.getProgress.bind(this);
	}

	componentWillMount() {
        this.getSmartTv();
	}

	componentDidMount() {
	    window.scrollTo(0, 0);
        this.props.setHeaderTitle("Smart TV");
        this.timeInterval = setInterval(() => {
            this.setState({
                currentTime: new Date()
            })
        }, 1000);
    }

    componentWillUnmount() {
	    if (this.timeInterval != null) {
            clearInterval(this.timeInterval);
        }
    }

    getSmartTv() {
	    this.props.show();
        axios.get(vars.BASE_API_URL+'/smartTvGuide')
            .then((response) => {
                console_log(response);
                if (response.data.success){
                    this.props.smartTvData(response.data.data);
                }
                this.props.hide();
            })
            .catch((error) => {
                this.props.hide();
                console_log(error);
            });
    }

    getCurrentProgram(channel) {
	    if (Array.isArray(channel.channelSummary.programs.program)) {
	        return channel.channelSummary.programs.program.filter((program) => {
                        if (isBetween(this.state.currentTime, program.start, program.end)) {
                            return program;
                            }
                        })[0];
        } else {
	        return channel.channelSummary.programs.program;
        }
    }

    getNextProgram(channel) {
        if (Array.isArray(channel.channelSummary.programs.program)) {
            let index = channel.channelSummary.programs.program.findIndex((program) => {
                if (isBetween(this.state.currentTime, program.start, program.end)) {
                    return program;
                }
            });
            if (index < channel.channelSummary.programs.program.length-1) {
                return channel.channelSummary.programs.program[index+1];
            } else {
                return channel.channelSummary.programs.program[index];
            }
        } else {
            return channel.channelSummary.programs.program;
        }
    }

    getProgress(start, end) {
	    let x = formatDate(this.state.currentTime, "X") - formatDate(start, "X"),
            y = formatDate(end, "X") - formatDate(start, "X");
        return x/y*100;
    }

	render() {
	    return (
			<section className="smart-tv py-0">
                {this.props.smartTV.smartTv.length > 0 ?
                    this.props.smartTV.smartTv.map((channel) => {
                        if (channel) {
                            let currentProgram = this.getCurrentProgram(channel);
                            let nextProgram = this.getNextProgram(channel);
                            return (
                                <Row key={channel.channelId}>
                                    <Col xs="12">
                                        <div className="video-list">
                                            <div className="video-list__item">
                                                <div className="video-list__image">
                                                    <div className="channels-image">
                                                        <div className="channels-image channels-image--genre channels-image--list no-radius">
                                                            <img className="channels-thumb__image" src={channel.channelImage ? vars.BASE_URL+"uploads/"+channel.channelImage : "./img/thumbnail-2.jpg"} alt={channel.channelName} />
                                                            <img className="channels-thumb__icon channel-thumb__icon--list" src={channel.channelLogo} alt={channel.channelName} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="video-list__details">
                                                    <div className="video-list__upper">
                                                        <div className="video-list__upper__left">
                                                            <span className="stream-text"><img className="now-stream-icon" src="./img/live-red.svg" />
                                                                <FormattedMessage id="nowStreaming"
                                                                    defaultMessage="Now Streaming"
                                                                />
                                                            </span>
                                                            <h4 className="channels-thumb__name channels-thumb__name--list">{(currentProgram)? currentProgram.name : " "}</h4>
                                                        </div>
                                                        <div className="video-list__upper__right">
                                                            <a className="view-all-btn" href={"/#/all/"+channel.channelId}>View All</a>
                                                            <span className="video-list__text">Up Next</span>
                                                            <h4 className="channels-thumb__name channels-thumb__name--list no-bold text-right">{(nextProgram) ? nextProgram.name : " "}</h4>
                                                        </div>
                                                    </div>
                                                    <Progress value={this.getProgress(currentProgram.start, currentProgram.end)} />
                                                    <div className="video-time">
                                                        <span className="video-start-time">{(currentProgram) ? formatDate(currentProgram.start, "HH:mm a"): " "}</span>
                                                        <span className="video-end-time">{(currentProgram) ? formatDate(currentProgram.end, "HH:mm a") : " "}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            )
                        }
                    })
                    : <div className="blank-text">
                        <p>
                            <FormattedMessage id="noData"
                                defaultMessage="No Data Available"
                            />
                        </p>
                    </div>
                }
			</section>
		)
	}
}

const mapStateToProps = (state) => {
    return {
        access: state.WelcomeReducer,
        account: state.AccountReducer,
        category: state.CategoryReducer,
        country: state.CountryReducer,
        domain: state.DomainReducer,
        favorite: state.FavoriteReducer,
        flashmessage: state.FlashMessageReducer,
        historyVideos: state.HistoryReducer,
        loader: state.ActivityIndicatorReducer,
        play: state.PlayReducer,
        smartTV: state.SmartTVReducer,
        splash: state.SplashScreenReducer,
        user: state.AuthenticationReducer
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        show,
        hide,
        setHeaderTitle,
        smartTvData
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(SmartTV);



// WEBPACK FOOTER //
// ./src/components/SmartTV/SmartTV.js